import { getApiBasePath } from "@/app/base-path";

import { getSessionId } from "../utils/user-session-id";

export async function userEvent(
  eventType: string,
  eventData?: Record<string, unknown>,
): Promise<void> {
  const url = `${getApiBasePath()}/api/userEvents/`;
  const body = JSON.stringify({
    event_type: eventType,
    session_id: getSessionId(),
    ...(eventData && { event_data: eventData }),
  });

  // The browser queues a beacon and delivers it independently of the document, so the event
  // still reaches the server when the scheduler immediately hands off to the confirmation app.
  // A plain fetch is bound to the page and gets aborted by that navigation.
  // sendBeacon cannot set headers, hence the Blob — its type becomes the Content-Type.
  try {
    if (
      typeof navigator?.sendBeacon === "function" &&
      navigator.sendBeacon(url, new Blob([body], { type: "application/json" }))
    ) {
      return;
    }
  } catch {
    // fall through to fetch
  }

  // sendBeacon returns false when the browser's beacon queue is over its 64KB budget, and is
  // absent outside a browser. keepalive gives the fallback the same detached lifetime.
  try {
    await fetch(url, {
      method: "POST",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body,
    });
  } catch {
    // swallow — user event tracking is non-critical and fires fire-and-forget via void
  }
}
